function hasWindow() {
    return typeof window !== 'undefined';
}
function hasNavigator() {
    return typeof navigator !== 'undefined';
}
function hasDocument() {
    return typeof document !== 'undefined';
}
function hasLocalStorage() {
    try {
        return typeof localStorage !== 'undefined';
    }
    catch (error) {
        return false;
    }
}
function hasSessionStorage() {
    try {
        return typeof sessionStorage !== 'undefined';
    }
    catch (error) {
        return false;
    }
}
function hasCookieStorage() {
    return hasNavigator() && navigator.cookieEnabled;
}
function hasCrypto() {
    return typeof crypto !== 'undefined';
}
function hasCryptoRandomValues() {
    return hasCrypto() && typeof crypto.getRandomValues !== 'undefined';
}
function hasLocation() {
    return typeof location !== 'undefined';
}

export { hasCookieStorage, hasCrypto, hasCryptoRandomValues, hasDocument, hasLocalStorage, hasLocation, hasNavigator, hasSessionStorage, hasWindow };
